export default __webpack_public_path__ + "static/media/MSExcel_Example_6.8b3d17a8.png";